
define('templates',['vendor/underscore'], function (_) { var templates = {};
templates['article'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n    ';
 if (article.has("title") && article.has("body")) { 
__p+='\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h1>'+
((__t=( article.get("title") ))==null?'':_.escape(__t))+
'</h1>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="breadcrumbs">\n              <li><a href="/">Página Inicial</a></li>\n              <li><a href="/ajuda/">Ajuda</a></li>\n              <li><a href="'+
((__t=( article.get('section').link ))==null?'':_.escape(__t))+
'">'+
((__t=( article.get('section').title ))==null?'':_.escape(__t))+
'</a></li>\n              <li class="current"><a href="'+
((__t=( article.get('link') ))==null?'':_.escape(__t))+
'">'+
((__t=( article.get("title") ))==null?'':_.escape(__t))+
'</a></li>\n            </ul>\n        </div>\n\t</div>\n    <div class="row">\n\t\t<div class="small-12 columns">\n            '+
((__t=( article.get("body") ))==null?'':__t)+
'\n        </div>\n\t</div>\n    ';
 } else { 
__p+='\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <b>Carregando..</b>\n        </div>\n\t</div>\n    ';
 } 
__p+='\n</div>';
}
return __p;
}
templates['blog'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h1>Blog';
 if(posts.getQuery()) { 
__p+=' - Buscando por "'+
((__t=( posts.getQuery() ))==null?'':_.escape(__t))+
'"';
 } 
__p+='</h1>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="breadcrumbs">\n              <li><a href="/">Página Inicial</a></li>\n              <li';
 if (!posts.getQuery()) { 
__p+=' class="current"';
 } 
__p+='><a href="/blog/">Blog</a></li>\n              ';
 if(posts.getQuery()) { 
__p+='<li class="current"><a href="/blog/?q='+
((__t=( posts.getQuery() ))==null?'':_.escape(__t))+
'">Resultados para "'+
((__t=( posts.getQuery() ))==null?'':_.escape(__t))+
'"</a></li>';
 } 
__p+='\n            </ul>\n        </div>\n\t</div>\n    <div class="row">\n        <div class="small-8 columns">\n        ';
 if (posts.length > 0) { 
__p+='\n        ';
 posts.each(function(post) { 
__p+='\n            <div class="row">\n                <div class="small-12 columns">\n                    <a href="'+
((__t=( post.get('link') ))==null?'':_.escape(__t))+
'"><h2>'+
((__t=( post.get("title") ))==null?'':_.escape(__t))+
'</h2></a>\n                </div>\n            </div>\n            <div class="row">\n                <div class="small-12 columns">\n                    '+
((__t=( post.get("summary") ))==null?'':__t)+
'\n                </div>\n            </div>\n        ';
 }); 
__p+='\n        <div class="row">\n            <div class="small-12 columns" id="pagination-container"></div>\n        </div>\n        ';
 } else { 
__p+='\n            <b>'+
((__t=( firstTime ? "Carregando posts..": "Nenhum post encontrado" ))==null?'':_.escape(__t))+
'</b>\n        ';
 } 
__p+='\n        </div>\n        <div class="small-4 columns">\n            <div class="row">\n                <div class="small-12 columns search-form"></div>\n            </div>\n            <div class="row">\n                <div class="small-12 columns categories"></div>\n            </div>\n        </div>\n\t</div>\n</div>';
}
return __p;
}
templates['calendar'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<thead>\n\t<tr>\n\t\t<th>\n\t\t</th>\n\t\t<th>\n\t\t\tSegunda\n\t\t</th>\n\t\t<th>\n\t\t\tTerça\n\t\t</th>\n\t\t<th>\n\t\t\tQuarta\n\t\t</th>\n\t\t<th>\n\t\t\tQuinta\n\t\t</th>\n\t\t<th>\n\t\t\tSexta\n\t\t</th>\n\t\t<th>\n\t\t\tSábado\n\t\t</th>\n\t</tr>\n</thead>\n<tbody>\n\t';
 for(var i = 0; i< hours.length;i++){
		var hour = hours[i];
	
__p+='\n\t<tr class="hour-'+
((__t=( i ))==null?'':_.escape(__t))+
'">\n\t\t<td>\n\t\t\t'+
((__t=( hour ))==null?'':_.escape(__t))+
'\n\t\t</td>\n\t\t';
 for(var j=1; j < 7; ++j){ 
__p+='\n\t\t\t<td style="text-align: center;'+
((__t=( events[i] && events[i][j] ?  'background-color: '+events[i][j].color+'; color:'+events[i][j].fontColor : '' ))==null?'':_.escape(__t))+
'; font-weight:'+
((__t=( events[i] && events[i][j] ? (events[i][j].highlight?'bold':'normal') : 'normal' ))==null?'':_.escape(__t))+
'" title="'+
((__t=( events[i] && events[i][j] ? events[i][j].name : default_name ))==null?'':__t)+
'" data-row="'+
((__t=( i ))==null?'':__t)+
'" data-column="'+
((__t=( j ))==null?'':__t)+
'" '+
((__t=( events[i] && events[i][j] && events[i][j].custom ? "data-schedule='"+events[i][j].schedule+"'" : "" ))==null?'':__t)+
'>'+
((__t=( events[i] && events[i][j] ? events[i][j].title:default_title ))==null?'':_.escape(__t))+
'</td>\n\t\t';
 } 
__p+='\n\t</tr>\n\t';
 } 
__p+='\n</tbody>\n\t\t\t\n\t\t\t';
}
return __p;
}
templates['categories'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (categories.length > 0) { 
__p+='\n    <div class="row">\n        <div class="small-12 columns">\n            <h4>'+
((__t=( title ))==null?'':_.escape(__t))+
'</h4>\n            <ul>\n                ';
 categories.each(function(category) { 
__p+='\n                    <li><a href="'+
((__t=( category.get('link') ))==null?'':_.escape(__t))+
'">'+
((__t=( category.get('title') ))==null?'':_.escape(__t))+
'</a></li>\n                ';
 }) 
__p+='\n            </ul>\n        </div>\n    </div>\n';
 } 
__p+='';
}
return __p;
}
templates['category'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h1>Blog - Categoria '+
((__t=( category.get('title') ))==null?'':_.escape(__t))+
'';
 if(posts.getQuery()) { 
__p+=' - Buscando por "'+
((__t=( posts.getQuery() ))==null?'':_.escape(__t))+
'"';
 } 
__p+='</h1>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="breadcrumbs">\n              <li><a href="/">Página Inicial</a></li>\n              <li><a href="/blog/">Blog</a></li>\n              <li';
 if (!posts.getQuery()) { 
__p+=' class="current"';
 } 
__p+='><a href="'+
((__t=( category.get('link') ))==null?'':_.escape(__t))+
'">'+
((__t=( category.get('title') ))==null?'':_.escape(__t))+
'</a></li>\n              ';
 if(posts.getQuery()) { 
__p+='<li class="current"><a href="/blog/?q='+
((__t=( posts.getQuery() ))==null?'':_.escape(__t))+
'">Resultados para "'+
((__t=( posts.getQuery() ))==null?'':_.escape(__t))+
'"</a></li>';
 } 
__p+='\n            </ul>\n        </div>\n\t</div>\n    <div class="row">\n        <div class="small-8 columns">\n        ';
 if (posts.length > 0) { 
__p+='\n        ';
 posts.each(function(post) { 
__p+='\n            <div class="row">\n                <div class="small-12 columns">\n                    <a href="'+
((__t=( post.get('link') ))==null?'':_.escape(__t))+
'"><h2>'+
((__t=( post.get("title") ))==null?'':_.escape(__t))+
'</h2></a>\n                </div>\n            </div>\n            <div class="row">\n                <div class="small-12 columns">\n                    '+
((__t=( post.get("summary") ))==null?'':__t)+
'\n                </div>\n            </div>\n        ';
 }); 
__p+='\n        <div class="row">\n            <div class="small-12 columns" id="pagination-container"></div>\n        </div>\n    ';
 } else { 
__p+='\n        <b>'+
((__t=( firstTime ? "Carregando posts..": "Nenhum post encontrado" ))==null?'':_.escape(__t))+
'</b>\n    ';
 } 
__p+='\n        </div>\n        <div class="small-4 columns">\n            <div class="row">\n                <div class="small-12 columns search-form"></div>\n            </div>\n            <div class="row">\n                <div class="small-12 columns categories"></div>\n            </div>\n        </div>\n    </div>\n</div>';
}
return __p;
}
templates['combinations'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n    <div class="small-12 columns">\n        <a href="#" title="Mostrar Gerenciador" class="toggle-combinations-manager"><b>Gerenciador de combinações</b></a>\n    </div>\n</div>\n<form style="display: none;">\n    <div class="row">\n        <div class="small-12 columns">\n            <b>Horas-aula</b>\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-3 columns">\n            <label for="minimum-ha" class="right">Minimo:</label>\n        </div>\n        <div class="small-3 columns">\n            <input type="number" id="minimum-ha" placeholder="Numero minimo de horas aula por semana de acordo com o curriculo do seu curso (carga horaria minima)" maxlength="3" />\n        </div>\n        <div class="small-3 columns">\n            <label for="maximum-ha" class="right">Máximo:</label>\n        </div>\n        <div class="small-3 columns">\n            <input type="number" id="maximum-ha" placeholder="Numero maximo de horas aula por semana de acordo com o curriculo do seu curso (carga horaria maxima)" maxlength="3" />\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-12 columns">\n            <b>Disciplinas</b>\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-3 columns">\n            <label for="minimum-disciplines" class="right">Minimo:</label>\n        </div>\n        <div class="small-3 columns">\n            <input type="number" id="minimum-disciplines" placeholder="Numero minimo de disciplinas que você deseja pegar" maxlength="3" />\n        </div>\n        <div class="small-3 columns">\n            <label for="maximum-disciplines" class="right">Máximo:</label>\n        </div>\n        <div class="small-3 columns">\n            <input type="number" id="maximum-disciplines" placeholder="Numero maximo de disciplinas que você deseja pegar" maxlength="3" />\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-12 columns">\n            <b>Periodos:</b>\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-4 columns">\n            <input type="checkbox" class="period" name="morning" id="period-morning" checked/> <label for="period-morning">Manhã</label>\n        </div>\n        <div class="small-4 columns">\n            <input type="checkbox" class="period" name="afternoon" id="period-afternoon" checked/> <label for="period-afternoon">Tarde</label>\n        </div>\n        <div class="small-4 columns">\n            <input type="checkbox" class="period" name="night" id="period-night" checked/> <label for="period-night">Noite</label>\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-12 columns">\n            <b>Dias:</b>\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-6 columns">\n            <input type="checkbox" class="dayOfWeek" name="1" id="dayOfWeek-monday" checked/><label for="dayOfWeek-monday">Segunda-Feira</label>\n        </div>\n        <div class="small-6 columns">\n            <input type="checkbox" class="dayOfWeek" name="2" id="dayOfWeek-tuesday" checked/><label for="dayOfWeek-tuesday">Terça-Feira</label>\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-6 columns">\n            <input type="checkbox" class="dayOfWeek" name="3" id="dayOfWeek-wednesday" checked/><label for="dayOfWeek-wednesday">Quarta-Feira</label>\n        </div>\n        <div class="small-6 columns">\n            <input type="checkbox" class="dayOfWeek" name="4" id="dayOfWeek-thursday" checked/><label for="dayOfWeek-thursday">Quinta-Feira</label>\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-6 columns">\n            <input type="checkbox" class="dayOfWeek" name="5" id="dayOfWeek-friday" checked/><label for="dayOfWeek-friday">Sexta-Feira</label>\n        </div>\n        <div class="small-6 columns">\n            <input type="checkbox" class="dayOfWeek" name="6" id="dayOfWeek-saturday" checked/><label for="dayOfWeek-saturday">Sábado</label>\n        </div>\n    </div>\n    <div class="row">\n        <div class="small-12 columns">\n            <a href="#" class="button expand">Salvar</a>\n        </div>\n    </div>\n</form>\n';
}
return __p;
}
templates['filters'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="small-12 medium-6 large-6 columns">\n\t<form class="form-line">\n\t\t<div class="row collapse">\n\t\t\t<div class="small-12 medium-6 columns">\n\t\t\t\t<div class="row">\n\t\t\t\t\t<div class="small-6 columns filter-label">\n\t\t\t\t\t\t<label for="semester" class="inline" title="Semestre no qual você pretende aplicar a simulação" data-tooltip>Semestre:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="small-6 columns filter-input" id="semester-field">\n\t\t\t\t\t\t<select id="semester" name="semester" style="width: 100%;"></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="small-12 medium-6 columns">\n\t\t\t\t<div class="row">\n\t\t\t\t\t<div class="small-6 columns filter-label">\n\t\t\t\t\t\t<label for="campus" class="inline" title="Campus no qual você pretende se matricular" data-tooltip>Campus:</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="small-6 columns filter-input" id="campus-field">\n\t\t\t\t\t\t<select id="campus" name="campus" style="width: 100%;"></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n</div>\n<div class="small-12 medium-6 large-6 large-offset-0 columns">\n\t<form class="form-line">\n\t\t<div class="row">\n\t\t\t<div class="small-3 columns filter-label">\n\t\t\t\t<label for="discipline" class="inline" data-tooltip title="Disciplina no qual você pretende se matricular">Disciplina:</label>\n\t\t\t</div>\n\t\t\t<div class="small-9 columns filter-input" id="discipline-field">\n\t\t\t\t<input type="text" id="discipline" name="discipline" style="width: 100%;" autocomplete="off"/>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n</div>\n<div class="small-12 columns" id="discipline-custom-settings"></div>';
}
return __p;
}
templates['footer'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row footer-block collapse">\n\t<div class="small-3 columns">\n      \t<ul class="inline-list">\n        \t<li><a href="/">Início</a></li>\n        \t<li><a href="/sobre/VPCrvCkAAPE-I8ch">Sobre</a></li>\n        \t<li><a href="/ajuda">Ajuda</a></li>\n        \t<li><a href="/blog">Blog</a></li>\n     \t</ul>\n  \t</div>\n    <div class="small-3 columns">\n        <div class="fb-like" data-href="http://facebook.com/MatrUFSC2" data-layout="standard" data-action="like" data-width="225" data-show-faces="true" data-share="false"></div>\n\t</div>\n\t<div class="small-6 columns">\n\t\tNão se esqueça de fazer sua matrícula no <a href="http://cagr.ufsc.br/"><b>CAGR</b></a>! Este aplicativo não tem nenhum vínculo com a UFSC e é mantido por <a href="https://github.com/matrufsc2/matrufsc2/graphs/contributors" target="_blank">contribuidores</a> que estudam (ou estudaram) na UFSC.\n\t</div>\n</div>';
}
return __p;
}
templates['header'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+=' <div class="top-bar" data-topbar role="navigation">\n    <ul class="title-area">\n        <li class="name">\n            <a href="/"><img src="/img/logo.png" border="0" alt="MatrUFSC2" /></a>\n        </li>\n    </ul>\n\n    <section class="top-bar-section">\n        <ul class="right">\n            <li><a href="/">Início</a></li>\n            <li class="divider"></li>\n            <li><a href="/sobre/VPCrvCkAAPE-I8ch/">Sobre</a></li>\n            <li class="divider"></li>\n            <li class="has-dropdown possibilities">\n                <a href="#">Plano</a>\n            </li>\n            <li class="divider"></li>\n            <li class="has-dropdown history">\n                <a href="#">Historico</a>\n            </li>\n            <li class="divider"></li>\n            <li>\n                <a href="#" class="auth noscript">Login</a>\n            </li>\n        </ul>\n    </section>\n</div>\n <div id="go-to-home" class="reveal-modal" data-reveal>\n  <h2>Erro!</h2>\n  <p>Esse botão não funciona aqui na página de sobre! Clique no botão "Início" localizado na barra superior para poder\n      usá-lo!</p>\n  <a class="close-reveal-modal">&#215;</a>\n</div>';
}
return __p;
}
templates['help'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h1>Ajuda</h1>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="breadcrumbs">\n              <li><a href="/">Página Inicial</a></li>\n              <li class="current"><a href="/ajuda/">Ajuda</a></li>\n            </ul>\n        </div>\n\t</div>\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <p>\n                Preparamos alguns conteúdos sobre variados assuntos que consideramos importantes para você,\n                estudante da UFSC. Se informe, e, se sentir falta de algo, mande sua sugestão para\n                <a href="http://facebook.com/messages/MatrUFSC2">a nossa página oficial do Facebook</a>. =)\n            </p>\n        </div>\n\t</div>\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="small-block-grid-4" data-equalizer>\n                <li style="background: '+
((__t=( getRandomColor() ))==null?'':_.escape(__t))+
'" data-equalizer-watch>\n                    <a href="/ajuda/perguntas-frequentes/" class="link-bold-title"><b>Perguntas Frequentes</b></a>\n                    <p>\n                        Perguntas e respostas comuns relacionadas ao MatrUFSC2 e a universidade em geral\n                    </p>\n                </li>\n                ';
 if (sections.length > 0) { 
__p+='\n                    ';
 sections.each(function(section){ 
__p+='\n                        <li style="background: '+
((__t=( getRandomColor() ))==null?'':_.escape(__t))+
'" data-equalizer-watch>\n                            <a href="'+
((__t=( section.get('link') ))==null?'':_.escape(__t))+
'" class="link-bold-title"><b>'+
((__t=( section.get("title") ))==null?'':_.escape(__t))+
'</b></a>\n                            '+
((__t=( section.get("description") ))==null?'':__t)+
'\n                        </li>\n                    ';
 }); 
__p+='\n                ';
 } 
__p+='\n            </ul>\n        </div>\n\t</div>\n</div>';
}
return __p;
}
templates['historicItem'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'" title="'+
((__t=( model.getFormattedDate() ))==null?'':_.escape(__t))+
'">'+
((__t=( model.getFormattedRelativeDate() ))==null?'':_.escape(__t))+
'</a>';
}
return __p;
}
templates['home'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="home-page">\n\t<div id="filters" class="row"></div>\n\t<div class="row">\n\t\t<div class="small-12 columns" id="disciplines-resume"></div>\n\t</div> \n\t<div id="calendar-container" class="row">\n\t\t<div class="small-12 medium-7 columns" id="calendar"></div>\n\t\t<div class="small-12 medium-5 columns" id="detail">\n            <div class="row">\n                <div class="small-12 columns" id="plans-container"></div>\n            </div>\n\t\t\t<div class="row">\n\t\t\t\t<div class="small-12 columns" id="teams-table-container"></div>\n\t\t\t</div>\n            <div class="row">\n\t\t\t\t<div class="small-12 columns" id="combinations-container"></div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n <div id="error-discipline" class="reveal-modal" data-reveal>\n  <h2>Erro!</h2>\n  <p></p>\n  <a class="close-reveal-modal">&#215;</a>\n</div>';
}
return __p;
}
templates['page'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n    ';
 if (model.has("title") && model.has("body")) { 
__p+='\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h2>'+
((__t=( model.get("title") ))==null?'':_.escape(__t))+
'</h2>\n        </div>\n\t</div>\n    <div class="row">\n\t\t<div class="small-12 columns">\n            '+
((__t=( model.get("body") ))==null?'':__t)+
'\n        </div>\n\t</div>\n    ';
 } else { 
__p+='\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <b>Carregando..</b>\n        </div>\n\t</div>\n    ';
 } 
__p+='\n</div>';
}
return __p;
}
templates['pagination'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul class="pagination">\n  <li class="arrow first-page '+
((__t=( firstItemClass ))==null?'':_.escape(__t))+
'"><a href="#">&laquo;</a></li>\n  ';
 if (firstPages.length > 0) { 
__p+='\n      ';
 _.each(firstPages, function(page) { 
__p+='\n        <li class="go-to-page"><a href="">'+
((__t=( page ))==null?'':_.escape(__t))+
'</a></li>\n      ';
 }) 
__p+='\n      <li class="unavailable"><a href="">&hellip;</a></li>\n  ';
 } 
__p+='\n  ';
 _.each(previousPages, function(page) { 
__p+='\n    <li class="go-to-page"><a href="">'+
((__t=( page ))==null?'':_.escape(__t))+
'</a></li>\n  ';
 }) 
__p+='\n  <li class="current"><a href="">'+
((__t=( currentPage ))==null?'':_.escape(__t))+
'</a></li>\n  ';
 _.each(nextPages, function(page) { 
__p+='\n    <li class="go-to-page"><a href="">'+
((__t=( page ))==null?'':_.escape(__t))+
'</a></li>\n  ';
 }) 
__p+='\n  ';
 if (endPages.length > 0) { 
__p+='\n      <li class="unavailable"><a href="">&hellip;</a></li>\n      ';
 _.each(endPages, function(page) { 
__p+='\n        <li class="go-to-page"><a href="">'+
((__t=( page ))==null?'':_.escape(__t))+
'</a></li>\n      ';
 }) 
__p+='\n  ';
 } 
__p+='\n  <li class="arrow last-page '+
((__t=( lastItemClass ))==null?'':_.escape(__t))+
'"><a href="#">&raquo;</a></li>\n</ul>';
}
return __p;
}
templates['plan'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="form-line">\n    <div class="row collapse">\n        <div class="small-8 columns">\n            <input type="text" placeholder="Informe seu identificador.." id="plan-code"/>\n        </div>\n        <div class="small-2 columns">\n            <a href="#" class="button postfix" id="open-button">Abrir</a>\n        </div>\n        <div class="small-2 columns">\n            <a href="#" class="button postfix" id="save-button">Salvar</a>\n        </div>\n    </div>\n</form>\n<div id="code-empty" class="reveal-modal" data-reveal>\n  <h2>Informe o identificador!</h2>\n  <p>Você precisa informar o identificador do plano que você deseja abrir ou salvá-lo para que possamos encontrar algo no sistema. Deixá-lo em branco <b>não é uma opção</b>.</p>\n  <a class="close-reveal-modal">&#215;</a>\n</div>\n<div id="plan-not-found" class="reveal-modal" data-reveal>\n  <h2>Erro!</h2>\n  <p>Nenhum plano foi encontrado para o identificador informado! Se você está tentando ver o plano de um amigo, peça para ele\n  a URL de compartilhamento do código. =)</p>\n  <a class="close-reveal-modal">&#215;</a>\n</div>\n<div id="plan-not-authenticated" class="reveal-modal" data-reveal>\n  <h2>Faça o login!</h2>\n  <p><a href="'+
((__t=( user.get('login_url') ))==null?'':_.escape(__t))+
'" class="auth">Faça o login</a> <b>gratuito</b> usando sua conta Google para poder salvar ou abrir planos no MatrUFSC2. Seu login será totalmente criptografado e\n  seu login e senha não serão salvos nos nossos servidores. Assim que você fizer login tentaremos abrir ou salvar o plano no código informado, conforme seu desejo. =)</p>\n  <p><a class="button alert auth" href="'+
((__t=( user.get('login_url') ))==null?'':_.escape(__t))+
'" class="auth">Fazer o login</a></p>\n  <a class="close-reveal-modal">&#215;</a>\n</div>';
}
return __p;
}
templates['possibility'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" data-id="'+
((__t=( model.id ))==null?'':_.escape(__t))+
'">Plano '+
((__t=( model.id ))==null?'':_.escape(__t))+
'</a>';
}
return __p;
}
templates['post'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n    ';
 if (post.has("title") && post.has("body")) { 
__p+='\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h1>'+
((__t=( post.get("title") ))==null?'':_.escape(__t))+
'</h1>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="breadcrumbs">\n              <li><a href="/">Página Inicial</a></li>\n              <li><a href="/blog/">Blog</a></li>\n              ';
 if (post.get("category")) { 
__p+='\n                <li><a href="'+
((__t=( post.get('category').link ))==null?'':_.escape(__t))+
'">'+
((__t=( post.get('category').title ))==null?'':_.escape(__t))+
'</a></li>\n              ';
 } 
__p+='\n              <li class="current"><a href="'+
((__t=( post.get('link') ))==null?'':_.escape(__t))+
'">'+
((__t=( post.get("title") ))==null?'':_.escape(__t))+
'</a></li>\n            </ul>\n        </div>\n\t</div>\n    <div class="row">\n\t\t<div class="small-12 columns">\n            '+
((__t=( post.get("body") ))==null?'':__t)+
'\n        </div>\n\t</div>\n    ';
 if (post.get("category")) { 
__p+='\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <b>Categoria</b>: <a href="'+
((__t=( post.get('category').link ))==null?'':_.escape(__t))+
'">'+
((__t=( post.get("category").title ))==null?'':_.escape(__t))+
'</a>\n        </div>\n\t</div>\n    ';
 } 
__p+='\n    <div class="related-posts"></div>\n    ';
 if (post.get("allow_comments")) { 
__p+='\n    <div class="comments">\n        <div class="row">\n            <div class="small-12 columns">\n                <h3><span class="fb-comments-count" data-href="'+
((__t=( post.get('full_link') ))==null?'':_.escape(__t))+
'"></span> comentário(s):</h3>\n            </div>\n        </div>\n        <div class="row">\n            <div class="small-12 columns">\n                <div class="fb-comments" data-href="'+
((__t=( post.get('full_link') ))==null?'':_.escape(__t))+
'" data-width="100%"></div>\n            </div>\n        </div>\n    </div>\n    ';
 } 
__p+='\n    ';
 } else { 
__p+='\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <b>Carregando..</b>\n        </div>\n\t</div>\n    ';
 } 
__p+='\n</div>';
}
return __p;
}
templates['questionsGroup'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n    ';
 if (model.has("title")) { 
__p+='\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h1>'+
((__t=( model.get("title") ))==null?'':_.escape(__t))+
'</h1>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="breadcrumbs">\n              <li><a href="/">Página Inicial</a></li>\n              <li><a href="/ajuda/">Ajuda</a></li>\n              <li><a href="/ajuda/perguntas-frequentes/">Perguntas Frequentes</a></li>\n              <li class="current"><a href="'+
((__t=( model.get('link') ))==null?'':_.escape(__t))+
'">'+
((__t=( model.get("title") ))==null?'':_.escape(__t))+
'</a></li>\n            </ul>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            '+
((__t=( model.get("description") ))==null?'':__t)+
'\n        </div>\n\t</div>\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="accordion" data-accordion>\n              ';
 model.eachQuestion(function(question, questionId) { 
__p+='\n              <li class="accordion-navigation">\n                <a href="#question'+
((__t=( questionId ))==null?'':_.escape(__t))+
'">'+
((__t=( question["question"] ))==null?'':_.escape(__t))+
'</a>\n                <div id="question'+
((__t=( questionId ))==null?'':_.escape(__t))+
'" class="content '+
((__t=( questionId == 0 ? 'active': '' ))==null?'':_.escape(__t))+
'">\n                    '+
((__t=( question["answer"] ))==null?'':__t)+
'\n                </div>\n              </li>\n              ';
 }) 
__p+='\n            </ul>\n        </div>\n\t</div>\n    ';
 } else { 
__p+='\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <b>Carregando..</b>\n        </div>\n\t</div>\n    ';
 } 
__p+='\n</div>';
}
return __p;
}
templates['questionsGroups'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h1>Perguntas Frequentes</h1>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="breadcrumbs">\n              <li><a href="/">Página Inicial</a></li>\n              <li><a href="/ajuda/">Ajuda</a></li>\n              <li class="current"><a href="/ajuda/perguntas-frequentes/">Perguntas Frequentes</a></li>\n            </ul>\n        </div>\n\t</div>\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <p>\n                Preparamos algumas perguntas e respostas sobre variados assuntos que consideramos importantes para você,\n                estudante da UFSC. Se informe, e, se sentir falta de algo, mande sua sugestão para\n                <a href="http://facebook.com/messages/MatrUFSC2" target="_blank">a nossa página oficial do Facebook</a>. =)\n            </p>\n        </div>\n\t</div>\n    <div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="small-block-grid-4" data-equalizer>\n                ';
 if (questionsGroups.length > 0) { 
__p+='\n                    ';
 questionsGroups.each(function(model){ 
__p+='\n                        <li style="background: '+
((__t=( getRandomColor() ))==null?'':_.escape(__t))+
'" data-equalizer-watch>\n                            <a href="'+
((__t=( model.get('link') ))==null?'':_.escape(__t))+
'" class="link-bold-title"><b>'+
((__t=( model.get("title") ))==null?'':_.escape(__t))+
'</b></a>\n                            '+
((__t=( model.get("description") ))==null?'':__t)+
'\n                        </li>\n                    ';
 }); 
__p+='\n                ';
 } else { 
__p+='\n                    <li data-equalizer-watch>'+
((__t=( firstTime ? "Carregando perguntas..": "Nenhuma pergunta encontrada" ))==null?'':_.escape(__t))+
'</li>\n                ';
 } 
__p+='\n            </ul>\n        </div>\n\t</div>\n</div>';
}
return __p;
}
templates['relatedPosts'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (posts.length > 0) { 
__p+='\n    <div class="row">\n        <div class="small-12 columns">\n            <h4>'+
((__t=( title ))==null?'':_.escape(__t))+
'</h4>\n            <ul>\n                ';
 posts.each(function(post) { 
__p+='\n                    <li><a href="'+
((__t=( post.get('link') ))==null?'':_.escape(__t))+
'">'+
((__t=( post.get('title') ))==null?'':_.escape(__t))+
'</a></li>\n                ';
 }) 
__p+='\n            </ul>\n        </div>\n    </div>\n';
 } 
__p+='';
}
return __p;
}
templates['searchForm'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n    <div class="small-12 columns">\n        <h4>Busca</h4>\n        <form>\n            <div class="row collapse">\n                <div class="small-8 columns">\n                    <input type="text" placeholder="Buscar.." name="q" id="q" value="'+
((__t=( q ))==null?'':_.escape(__t))+
'"/>\n                </div>\n                <div class="small-4 columns">\n                    <input type="submit" value="Buscar" class="button postfix"/>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>';
}
return __p;
}
templates['section'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="content-page">\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <h1>Ajuda - Seção '+
((__t=( section.get("title") ))==null?'':_.escape(__t))+
'';
 if(articles.getQuery()) { 
__p+=' - Buscando por "'+
((__t=( articles.getQuery() ))==null?'':_.escape(__t))+
'"';
 } 
__p+='</h1>\n        </div>\n\t</div>\n\t<div class="row">\n\t\t<div class="small-12 columns">\n            <ul class="breadcrumbs">\n              <li><a href="/">Página Inicial</a></li>\n              <li><a href="/ajuda/">Ajuda</a></li>\n              <li';
 if (!articles.getQuery()) { 
__p+=' class="current"';
 } 
__p+='><a href="'+
((__t=( section.get('link') ))==null?'':_.escape(__t))+
'">'+
((__t=( section.get("title") ))==null?'':_.escape(__t))+
'</a></li>\n              ';
 if(articles.getQuery()) { 
__p+='<li class="current"><a href="/blog/?q='+
((__t=( articles.getQuery() ))==null?'':_.escape(__t))+
'">Resultados para "'+
((__t=( articles.getQuery() ))==null?'':_.escape(__t))+
'"</a></li>';
 } 
__p+='\n            </ul>\n        </div>\n\t</div>\n    <div class="row">\n        <div class="small-8 columns">\n            ';
 if (articles.length > 0) { 
__p+='\n            ';
 articles.each(function(article) { 
__p+='\n                <div class="row">\n                    <div class="small-12 columns">\n                        <a href="'+
((__t=( article.get('link') ))==null?'':_.escape(__t))+
'"><h2>'+
((__t=( article.get("title") ))==null?'':_.escape(__t))+
'</h2></a>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="small-12 columns">\n                        '+
((__t=( article.get("summary") ))==null?'':__t)+
'\n                    </div>\n                </div>\n            ';
 }); 
__p+='\n            <div class="row">\n                <div class="small-12 columns" id="pagination-container"></div>\n            </div>\n            ';
 } else { 
__p+='\n                    <b>'+
((__t=( firstTime ? "Carregando artigos..": "Nenhum artigo encontrado" ))==null?'':_.escape(__t))+
'</b>\n            ';
 } 
__p+='\n        </div>\n        <div class="small-4 columns">\n            <div class="row">\n                <div class="small-12 columns search-form"></div>\n            </div>\n            <div class="row">\n                <div class="small-12 columns sections"></div>\n            </div>\n        </div>\n\t</div>\n</div>';
}
return __p;
}
templates['selectedDiscipline'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="text-center">\n    <fieldset class="switch tiny show-for-small-only" tabindex="0">\n\t\t<input type="checkbox" class="selectedDiscipline" id="selectedDiscipline-'+
((__t=( discipline.id ))==null?'':_.escape(__t))+
'" '+
((__t=( discipline.isDisciplineEnabled() ? 'checked="checked"':'' ))==null?'':_.escape(__t))+
' />\n\t\t<label for="selectedDiscipline-'+
((__t=( discipline.id ))==null?'':_.escape(__t))+
'"></label>\n    </fieldset>\n    <input type="checkbox" class="selectedDiscipline hide-for-small-only" '+
((__t=( discipline.isDisciplineEnabled() ? 'checked="checked"':'' ))==null?'':_.escape(__t))+
' />\n</td>\n<td title="'+
((__t=( discipline.get('_title') ))==null?'':_.escape(__t))+
'" class="title '+
((__t=( !is_editing && discipline.has('_title') ? 'has-tip': '' ))==null?'':_.escape(__t))+
'" data-tooltip>';
 if(is_editing) {
    
__p+='<a title="Editar nome da disciplina" class="has-tip discipline-name" href="#" data-tooltip>'+
((__t=( discipline.get("code") ))==null?'':_.escape(__t))+
' - '+
((__t=( discipline.get("name") ))==null?'':_.escape(__t))+
'</a>';
 } else { 
__p+=''+
((__t=( discipline.get("code") ))==null?'':_.escape(__t))+
' - '+
((__t=( discipline.get("name") ))==null?'':_.escape(__t))+
'';
 } 
__p+='</td>\n<td class="text-center">'+
((__t=( discipline.team ? discipline.team.get("code") : (!discipline.teams.isSynced() ? "Carregando..." : "-")  ))==null?'':_.escape(__t))+
'</td>\n<td class="text-center">'+
((__t=( discipline.team ? discipline.team.getNumberOfLessons() : '-' ))==null?'':_.escape(__t))+
'</td>\n<td class="text-center">'+
((__t=( discipline.semester ? discipline.semester.get("name") : '-' ))==null?'':_.escape(__t))+
'</td>\n<td class="text-center"><a href=\'#\' title="'+
((__t=( !is_editing || !can_edit ? 'Editar disciplina': 'Salvar' ))==null?'':__t)+
'"><i class="icon-'+
((__t=( !is_editing || !can_edit ? 'edit': 'ok' ))==null?'':__t)+
' '+
((__t=( can_edit ? '': 'disabled' ))==null?'':__t)+
'"></i></a></td>\n<td class="text-center"><a href=\'#\'><i class="icon-up"></i></a></td>\n<td class="text-center"><a href=\'#\'><i class="icon-down"></i></a></td>\n<td class="text-center"><a href=\'#\'><i class="icon-delete"></i></a></td>';
}
return __p;
}
templates['selectedDisciplines'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<thead>\n\t<tr>\n        <th></th>\n\t\t<th>Código</th>\n\t\t<th>Turma</th>\n\t\t<th>Horas-Aula</th>\n\t\t<th>Período</th>\n\t\t<th class="text-right" colspan="2">\n\t\t\t<a href="#" id="previousCombination"><i class="icon-left"></i></a>\n\t\t</th>\n\t\t<th id="combinationStatus" class="text-center"></th>\n\t\t<th class="text-left">\n\t\t\t<a href="#" id="nextCombination"><i class="icon-right"></i></a>\n\t\t</th>\n\t</tr>\n</thead>\n<tbody></tbody>\n<tfoot>\n\t<tr>\n        <td colspan="2"></td>\n        <td>\n            Total:\n        </td>\n        <td id="totalHours" class="text-center"></td>\n        <td colspan="5"></td>\n    </tr>\n</tfoot>';
}
return __p;
}
templates['selectedTeam'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="text-center">\n    ';
 if(is_editing_discipline) { 
__p+='\n        ';
 if (is_editing_team) { 
__p+='\n            <a href="#" title="Salvar Turma"><i class="icon-ok"></i></a>\n        ';
 } else { 
__p+='\n            <a href="#" title="Editar Turma"><i class="icon-edit"></i></a>\n        ';
 } 
__p+='\n    ';
 } else { 
__p+='\n    <fieldset class="switch tiny show-for-small-only" tabindex="0">\n\t\t<input type="checkbox" class="selectedTeam" id="selectedTeam-'+
((__t=( team.id ))==null?'':_.escape(__t))+
'" '+
((__t=( team.get("_selected") ? 'checked="checked"':'' ))==null?'':_.escape(__t))+
' />\n\t\t<label for="selectedTeam-'+
((__t=( team.id ))==null?'':_.escape(__t))+
'"></label>\n    </fieldset>\n    <input type="checkbox" class="selectedTeam hide-for-small-only" '+
((__t=( team.get("_selected") ? 'checked="checked"':'' ))==null?'':_.escape(__t))+
' />\n    ';
 } 
__p+='\n</td>\n<td>\n    <a data-dropdown="menu'+
((__t=( team.id ))==null?'':_.escape(__t))+
'" aria-controls="menu'+
((__t=( team.get('id') ))==null?'':_.escape(__t))+
'" aria-expanded="false" class="has-tip" title="Clique para ver opções" data-tooltip>'+
((__t=( team.get("code") ))==null?'':__t)+
'</a>\n    <ul id="menu'+
((__t=( team.id ))==null?'':_.escape(__t))+
'" class="f-dropdown" data-dropdown-content aria-hidden="true" tabindex="-1">\n      ';
 if (is_editing_discipline) { 
__p+='<li><a href="#" class="removeTeam">Apagar turma</a></li> ';
 } 
__p+='\n      <li><a href="#" class="deselectAnothers">Selecionar só essa turma</a></li>\n    </ul>\n</td>\n<td>\n\t'+
((__t=( team.get("vacancies_filled") ))==null?'':_.escape(__t))+
'/'+
((__t=( team.get("vacancies_offered") ))==null?'':_.escape(__t))+
'\n</td>\n<td>\n\t'+
((__t=( _.pluck(team.get("teachers"), 'name').join(", ") ))==null?'':_.escape(__t))+
'\n</td>';
}
return __p;
}
templates['selectedTeams'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<thead>\n\t<tr>\n\t\t<th></th>\n\t\t<th>\n\t\t\tTurma\n\t\t</th>\n\t\t<th>\n\t\t\tVagas\n\t\t</th>\n\t\t<th>\n\t\t\tProfessores\n\t\t</th>\n\t</tr>\n</thead>\n<tbody></tbody>\n<tfoot>\n    ';
 if (is_editing) { 
__p+='\n    <tr>\n        <td colspan="4"><a href="#" id="add-team">Adicionar Turma</a></td>\n    </tr>\n    ';
 } else { 
__p+='\n\t<tr>\n\t\t<td>\n\t\t\t<input type="checkbox" id="groupTeams" checked="checked"/>\n\t\t</td>\n\t\t<td colspan="3">\n\t\t\t<label for="groupTeams">Agrupar turmas com horários iguais</label>\n\t\t</td>\n\t</tr>\n    ';
 } 
__p+='\n</tfoot>';
}
return __p;
}
templates['site'] = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section id=\'header\'></section>\n<section id=\'main\'></section>\n<section id="footer"></section>';
}
return __p;
}
return templates; });